export const floorplanPins = [];

/**
 * Handle when a user clicks on a floorplan.
 */
export const listenToFloorplanClick = () => {
    if ($('.floorplan-image-wrapper:not(.no-edit)').length === 0) {
        return false;
    }

    $('.floorplan-image-wrapper:not(.no-edit)').on('click', 'img', function (e) {
        const bounds = this.getBoundingClientRect();
        const left = bounds.left;
        const top = bounds.top;
        const x = Math.round(e.pageX - left - window.scrollX);
        const y = Math.round(e.pageY - top - window.scrollY);
        const cw = this.clientWidth;
        const ch = this.clientHeight;
        const iw = this.naturalWidth;
        const ih = this.naturalHeight;
        const px = Math.round(x / cw * iw);
        const py = Math.round(y / ch * ih);

        const $wrapper = $(this).parent();

        // Do we have less than 5 pins?
        if (floorplanPins.length < 5) {
            $wrapper.append(`<div class="pin" data-x="${px}" data-y="${py}" style="left: ${x}px; top: ${y}px;"></div>`);
        } else {
            return alert('You may only have 5 pins on a floorplan. Click a pin to remove it.');
        }

        // Ensure our inputs are correct.
        $wrapper.find('input[name="floorplan_data_old"]').attr('name', 'floorplan_data');
        $wrapper.find('input[name="house_type_floorplan_id_old"]').attr('name', 'house_type_floorplan_id');

        // Update our stored pins.
        floorplanPins.push({
            x: px,
            y: py,
        });

        // Set the hidden input.
        $wrapper.find('input[name="floorplan_data"]').val(JSON.stringify(floorplanPins));

        // Are we dealing with floorplans in a group?
        if ($wrapper.parent().hasClass('tab-pane')) {
            // Clear the other floorplans' pins.
            $wrapper.closest('.tab-content').find('.floorplan-image-wrapper').not($wrapper).find('.pin').remove();

            // Change the other floorplans' inputs.
            $wrapper.closest('.tab-content').find('.floorplan-image-wrapper').not($wrapper).find('input[name="floorplan_data"]').attr('name', 'floorplan_data_old');
            $wrapper.closest('.tab-content').find('.floorplan-image-wrapper').not($wrapper).find('input[name="house_type_floorplan_id"]').attr('name', 'house_type_floorplan_id_old');
        }

        // Update the pins count.
        if (!$wrapper.find('.pin-count').length) {
            $wrapper.append('<h6 class="pin-count mt-2 mb-0"></h6>');
        }

        $wrapper.find('.pin-count').text(`${floorplanPins.length}/5 pins used`);

        // Listen to clicks on the created pin.
        handlePinClicks($wrapper);
    });
};

export const handlePinClicks = ($wrapper) => {
    $wrapper.find('.pin').off('click');

    // Don't bind events if it's not supposed to be edited.
    if ($wrapper.hasClass('no-edit')) {
        return false;
    }

    $wrapper.find('.pin').on('click', function () {
        // Find the floorplan pins index from the data attributes.
        const index = floorplanPins.findIndex(pin => pin.x == $(this).data('x') && pin.y == $(this).data('y'));

        if (index === -1) {
            return console.error('Error finding floorplan pin index');
        }

        // Remove the pin.
        $(this).remove();
        floorplanPins.splice(index, 1);

        $wrapper.find('.pin-count').text(`${floorplanPins.length}/5 pins used`);

        // Set the hidden input.
        $wrapper.find('input[name="floorplan_data"]').val(JSON.stringify(floorplanPins));
    });
};

export const createFloorplanPins = () => {
    floorplanPins.length = 0;

    $('.floorplan-image-wrapper').each(function () {
        const $wrapper = $(this);
        const data = $wrapper.find('input[name="floorplan_data"]').val();

        // Remove any existing pins.
        $wrapper.find('.pin').remove();

        if (data && data.trim() !== '') {
            const pins = JSON.parse(data);
            const $image = $wrapper.find('img');

            // Is the image visible?
            if (!$image.is(':visible')) {
                return;
            }

            // Calculate relative position to the image.
            const cw = $image[0].clientWidth;
            const ch = $image[0].clientHeight;
            const iw = $image[0].naturalWidth;
            const ih = $image[0].naturalHeight;

            // Create the or update the pin.
            pins.forEach(pin => {
                const px = Math.round(pin.x / iw * cw);
                const py = Math.round(pin.y / ih * ch);
                $wrapper.append(`<div class="pin" data-x="${px}" data-y="${py}" style="left: ${px}px; top: ${py}px;"></div>`);

                // Update our stored pins.
                floorplanPins.push({
                    x: px,
                    y: py,
                });
            });
        } else {
            // Set inputs to old.
            $wrapper.find('input[name="floorplan_data"]').attr('name', 'floorplan_data_old');
            $wrapper.find('input[name="house_type_floorplan_id"]').attr('name', 'house_type_floorplan_id_old');
        }

        // Update the pins count.
        if (!$wrapper.find('.pin-count').length) {
            $wrapper.append('<h6 class="pin-count mt-2 mb-0"></h6>');
        }

        $wrapper.find('.pin-count').text(`${floorplanPins.length}/5 pins used`);

        // Listen to clicks on the created pin.
        handlePinClicks($wrapper);
    });
};